module.exports = __webpack_public_path__ + "assets/img/Type BS (21).53af0d2a.jpg";